// NPM Imports
import React, { Component } from "react";
import Modal from "react-responsive-modal";
import { Button } from "@revvsales/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Internal Imports
// import formModeImage from "../../../../assets/send-anyway-popup.png";
import UNFILLED_FORM_FILLED from "../../../../assets/unfilled-form-filled.gif";

class UnFilledFormFields extends Component {
  state = {};

  _onSend = () => {
    this._onClose({ triggerNxt: true });
  };

  _onClose = value => {
    this.props.onClose(value);
  };

  render() {
    const fillerUnassignedValue = [];
    const fillerAssignedRecipentValue = [];
    this.props.formFields.forEach(element => {
      if (element.value && element.value.length !== 0)
        fillerUnassignedValue.push(element);
      if (element.filler_type === "RECIPIENT") {
        fillerAssignedRecipentValue.push(element);
      }
    });
    return (
      <Modal
        open
        onClose={this._onClose}
        center
        closeOnOverlayClick={false}
        classNames={{
          modal: "sendconfirmationmodal",
        }}>
        <div className="send-confirmation-popup-wrapper">
          <div className="send-confirmation-body">
            <div className="send-confirmation-header">
              <span>
                <FontAwesomeIcon
                  className="emptysigner-popup-exclamation-icon"
                  icon={["fas", "exclamation-triangle"]}
                />
                {`You have ${this.props.formFields.length -
                  fillerUnassignedValue.length} unfilled form fields`}
              </span>
            </div>
            <div className="send-confirmation-body-wrapper">
              <div className="send-confirmation-body-info">
                <b>
                  {" "}
                  {`You have assigned ${fillerAssignedRecipentValue.length}/${
                    this.props.formFields.length
                  } fields to recipients and left  ${this.props.formFields
                    .length - fillerUnassignedValue.length}/ ${
                    this.props.formFields.length
                  } empty.`}
                </b>
                <div
                  style={{
                    marginTop: "10px",
                  }}>
                  <div className="send-confirmation-body-list-item">
                    <div className="send-confirmation-body-dot">&#8226;</div>
                    <div className="send-confirmation-list-info">
                      If you missed filling them, go{" "}
                      <strong>back to document</strong> to fill them out. <br />{" "}
                      OR
                    </div>
                  </div>

                  <div className="send-confirmation-body-list-item">
                    <div className="send-confirmation-body-dot">&#8226;</div>
                    <div className="send-confirmation-list-info">
                      Continue to <strong>Next</strong> step where you can
                      review signer details and give fill permission to
                      recipeints if needed.
                    </div>
                  </div>
                </div>
              </div>
              <div className="send-confirmation-body-image-wrapper">
                <img
                  src={UNFILLED_FORM_FILLED}
                  alt="form-mode-check"
                  className="send-confirmation-body-image"
                />
              </div>
            </div>
          </div>
          <div className="send-confirmation-footer">
            <Button
              className="send-confirmation-btn-inherit"
              onClick={this._onClose}
              onKeyPress={() => {}}
              data-test="unfilledformfields-back-btn">
              Back to document
            </Button>
            <Button
              className="revv-btn-primary"
              onClick={this._onSend}
              onKeyPress={() => {}}
              data-test="unfilledformfields-send-anyway-btn">
              Next
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default UnFilledFormFields;



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV3/Popups/UnFilledFormFields/index.js